module.exports = __webpack_public_path__ + "img/gou.2deb55f9.svg";